'use client';

import { createContext, useEffect, useRef, useState, ReactNode } from 'react';
import { usePathname } from 'next/navigation';

type PageHistoryContextType = {
  previousPage: string | null,
  isExternalReferrer: boolean,
}

export const PageHistoryContext = createContext<PageHistoryContextType>({} as PageHistoryContextType);

export const PageHistoryProvider = ({ children }: {children: ReactNode}) => {
  const pathname = usePathname();
  const ref = useRef<string>(undefined);
  const firstRun = useRef<boolean>(true);
  const [ isExternalReferrer, setIsExternalReferrer ] = useState<boolean>(false);
  const [ previousPage, setPreviousPage ] = useState<string | null>(null);

  useEffect(() => {
    const referrerURL = document.referrer;

    if (!referrerURL.includes(window.location.hostname)) {
      setIsExternalReferrer(true);
    } else {
      setIsExternalReferrer(false);
    }
  }, []);

  useEffect(() => {
    // Only run once on page load.
    if (!firstRun.current) {
      setIsExternalReferrer(false);
      return;
    };

    firstRun.current = false;

    const prevPage = sessionStorage.getItem('previousPage');

    ref.current = pathname;
    if (prevPage?.toString() !== pathname.toString()) {
      setPreviousPage(ref.current);
      sessionStorage.setItem('previousPage', ref.current);
    }
  }, [ pathname ]);

  return <>
    <PageHistoryContext.Provider value={{ previousPage, isExternalReferrer }}>
      {children}
    </PageHistoryContext.Provider>
  </>;
};

export default PageHistoryContext;
